import {
    Box,
    Button,
    Center,
    Container,
    Divider,
    Heading,
    Image,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    Text
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { merge, tap } from "rxjs";
import { RoyaltiesInfo } from "../core/RoyaltiesInfo";
import Web3Service from "../core/web3.service";
import RewardsImage from "../images/rewards.webp";

// TODO: MOVE
function nFormatter(num: number, digits: number) {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : num.toFixed(2);

}

interface RoyaltiesClaimerProps { }

const RoyaltiesClaimer: React.FC<RoyaltiesClaimerProps> = (props) => {
    const web3Service = Web3Service.shared();

    const [account, setAccount] = useState<string | undefined>(undefined);
    const [royalties, setRoyalties] = useState<RoyaltiesInfo | undefined>(undefined);
    const [bagRoyalties, setBagRoyalties] = useState<RoyaltiesInfo | undefined>(undefined);
    const [boxRoyalties, setBoxRoyalties] = useState<RoyaltiesInfo | undefined>(undefined);

    useEffect(() => {
        web3Service.getRoyalties();
        web3Service.getBagRoyalties();
        web3Service.getBoxRoyalties();

        const account$ = web3Service.account$.pipe(
            tap((account) => {
                setAccount(account);
            })
        );

        const royalties$ = web3Service.royaltiesInfo$.pipe(
            tap((royalties) => {
                setRoyalties(royalties);
            })
        );

        const bagRoyalties$ = web3Service.bagRoyaltiesInfo$.pipe(
            tap((royalties) => {
                setBagRoyalties(royalties);
            })
        );

        const boxRoyalties$ = web3Service.boxRoyaltiesInfo$.pipe(
            tap((royalties) => {
                setBoxRoyalties(royalties);
            })
        );

        const subscription = merge(
            royalties$,
            bagRoyalties$,
            boxRoyalties$,
            account$
        ).subscribe();

        return () => {
            subscription.unsubscribe();
        };
    }, [account]);

    // let totalRoyalties = royalties?.totalRoyalties;
    // let formattedTotalRoyalties = totalRoyalties ? nFormatter(totalRoyalties, 2) : undefined;

    let content = <>
        {RoyaltiesSection("Safe Box", `${boxRoyalties?.availableToClaim ?? '-'} CRO`, boxRoyalties?.totalRoyalties ?? 0, web3Service.claimAllBoxRoyalties)}
        <Divider my={8} />
        {RoyaltiesSection("Money Bag", `${bagRoyalties?.availableToClaim ?? '-'} CRO`, bagRoyalties?.totalRoyalties ?? 0, web3Service.claimAllBagRoyalties)}
        <Divider my={8} />
        {RoyaltiesSection("Membership Card", `${royalties?.availableToClaim ?? '-'} CRO`, royalties?.totalRoyalties ?? 0, web3Service.claimAllRoyalties)}
    </>

    let connectWallet = <>
        <Container>
            <Center mt={8}>
                <Text maxW={'2xl'}>Connect Wallet to see royalties available to claim</Text>
            </Center>
            <Center mt={8}>
                <Button size={{ base: 'sm', sm: 'sm', md: 'md' }} color={'rgb(218, 165, 32)'} onClick={web3Service.toggleConnect}>
                    {"Connect Wallet"}
                </Button>
            </Center>
        </Container>
    </>

    return (
        <>
            <Center>
                <Image src={RewardsImage} />
            </Center>
            <Center>
                <Box textColor={'rgb(218, 165, 32)'}>
                    {account ? content : connectWallet}
                </Box>
            </Center>
        </>
    );
};

export default RoyaltiesClaimer;

function RoyaltiesSection(title: string, available: string, total: number, claim: React.MouseEventHandler<HTMLButtonElement>) {
    let formattedTotalRoyalties = total > 1000 ? nFormatter(total, 2) : total;

    return (
        <>
            <Heading w={'100%'} textColor={'rgb(218, 165, 32)'} textAlign={"center"} fontFamily={"Sedgwick Ave Display"} fontSize={'4xl'}>{title}</Heading>
            <SimpleGrid
                textColor={'rgb(255, 255, 255)'}
                columns={{ base: 1, md: 2 }}
                spacing={{ base: 4, md: 8 }}
                my={{ base: 4, md: 8 }}
                mx={"auto"}
                maxW={"6xl"}
            >
                <Stat
                    rounded={"xl"}
                    boxShadow={"md"}
                    bg={"rgba(23, 23, 23, 0.5)"}
                    border={'2px solid rgb(218, 165, 32)'}
                    maxWidth={{ base: 360, md: 480 }}
                    p={{ base: 4, md: 8 }}
                >
                    <StatLabel>Available to claim</StatLabel>
                    <StatNumber>{available}</StatNumber>
                </Stat>

                <Stat
                    rounded={"xl"}
                    boxShadow={"md"}
                    bg={"rgba(23, 23, 23, 0.5)"}
                    border={'2px solid rgb(218, 165, 32)'}
                    maxWidth={{ base: 360, md: 480 }}
                    p={{ base: 4, md: 8 }}
                >
                    <StatLabel>Total Distributed</StatLabel>
                    <StatNumber>{formattedTotalRoyalties} CRO</StatNumber>
                </Stat>
            </SimpleGrid>

            <Center>
                <Button size={{ base: 'sm', sm: 'sm', md: 'md' }} color={'rgb(218, 165, 32)'} onClick={claim}>
                    {`Claim ${available}`}
                </Button>
            </Center>
        </>
    );
}